import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { version } from "../../package.json";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import SyncIcon from "@material-ui/icons/Sync";
import ProfileIcon from "@material-ui/icons/AccountBox";
import { GoogleLogout } from "react-google-login";
import ProfileModal from "./Layout/ProfileModal";
import logo from "../images/Logo.png";
import {
	loadLocationTitle,
	setDebugging,
} from "../redux/contextInfos/contextInfosActions";
import { clearUsers } from "../redux/users/usersActions";
import withAuth from "./withAuth";
import "./MenuAppBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import AutoRenewIcon from "@material-ui/icons/Autorenew";
import WarningIcon from "@material-ui/icons/Warning";
import { actualizeWaitingRequests } from "../redux/serviceWorker/swActions";
import { getStateAccessor } from "../lib/evaluateStringAsCodeHelper.js";
import { MULTIPLE_CLICK_TIMEOUT } from "../constants";

const styles = {
	flex: {
		flex: 1,
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20,
	},
	logoutButton: {
		background: "#FE5815",
		border: "none!important",
		fontSize: "1rem!important",
		width: "auto",
	},
};

class ExternalMenuAppBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			auth: this.props.activeUser !== null,
			nbLogoClick: 0,
			anchorEl: null,
		};

		this.props.loadActiveUser((user) => {
			if (!user)
				return

			this.props.getSynchroActiveUser(this.state, true);
		})
	}

	componentDidMount() {
		this.props.loadLocationTitle();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props.hideMenu !== nextProps.hideMenu ||
			this.props.waitingRequests.length !== nextProps.waitingRequests.length ||
			this.props.locationTitle !== nextProps.locationTitle ||
			this.state.anchorEl !== nextState.anchorEl
		);
	}

	handleChange(event, checked) {
		this.setState({ auth: checked });
	}

	handleMenu(event) {
		this.setState({ anchorEl: event.currentTarget });
	}

	handleClose() {
		this.setState({ anchorEl: null });
	}

	goBack() {
		if (
			this.props.history.location.pathname.startsWith("/siteMonitorings/")
		) {
			this.props.history.push("/siteMonitorings");
		} else if (
			this.props.history.location.pathname.startsWith("/siteMonitorings")
		) {
			this.props.history.push("/");
		} else {
			this.props.history.goBack();
		}
	}

	onLogoClick() {
		if (this.state.nbLogoClick) {
			clearTimeout(this.state.logoClickTimeout);
		}

		this.setState({
			nbLogoClick: this.state.nbLogoClick + 1,
			logoClickTimeout: setTimeout(() => {
				if (this.state.nbLogoClick === 5) {
					if (
						this.props.context.debugging ||
						window.confirm(
							"Le mode debug va se lancer. Ce mode est exclusivement réservé aux administrateurs. Êtes-vous sûr de vouloir continuer?"
						)
					)
						this.props.setDebugging(!this.props.context.debugging);
				}

				this.setState({
					nbLogoClick: 0,
				});
			}, MULTIPLE_CLICK_TIMEOUT),
		});
	}

	goHome() {
		this.props.history.push("/");
	}

	logout() {
		this.props.clearUsers();
		this.props.history.push("/Login");
	}

	signout() {
		this.props.clearUsers();
		this.props.history.push("/Login");
	}

	synchronization() {
		this.props.synchronization(
			this.state,
			getStateAccessor(this.props),
			this.props.history,
			null,
			this.props.siteMonitoringsFilters,
			true
		);
	}

	render() {
		const { classes } = this.props;
		const anchorEl = this.state.anchorEl;
		const open = Boolean(anchorEl);

		let waitingRequestsBtn = null;

		let locationTitle = this.props.locationTitle.toUpperCase();

		if (
			this.props.siteMonitoring &&
			this.props.siteMonitoring.currentSiteMonitoring &&
			this.props.siteMonitoring.currentSiteMonitoring.code &&
			this.props.location.pathname === "/siteMonitorings/siteMonitoring"
		)
			locationTitle = this.props.siteMonitoring.currentSiteMonitoring.code;

		if (
			this.props.waitingRequests.length > 0 &&
			this.props.location.pathname === "/"
		)
			waitingRequestsBtn = (
				<Tooltip id="tooltip-icon" title="Actions en attente de réseau">
					<Button
						className="badge-div-center white_button"
						onClick={this.synchronization.bind(this)}
					>
						<AutoRenewIcon
							className="white-icon margin-auto-renew-btn"
							fontSize="large"
						/>
						<span className="badge activity-badge-notify">
							{this.props.waitingRequests.length}
						</span>
						<WarningIcon
							className="badge warn-badge"
							color="secondary"
							style={{ fontSize: 25 }}
						/>
					</Button>
				</Tooltip>
			);

		return (
			<div
				style={{
					width: "100%",
					height: "auto",
					maxHeight: "15%",
					display: "inline-flex",
				}}
				className={this.props.hideMenu ? "hide-sticky-menu" : "sticky-menu"}
			>
				<ProfileModal />
				<AppBar position="static" style={{ maxHeight: "100%", height: "100%" }}>
					<Toolbar
						style={{
							maxHeight: "100%",
							height: "100%",
							minHeight: "100%",
							padding: "0px",
							backgroundColor: "rgba(0, 97, 187, 0.5)",
						}}
					>
						{this.props.location.pathname !== "/" ? (
							<div>
								<Button
									color="inherit"
									aria-label="Back"
									onClick={this.goBack.bind(this)}
									className="white_button"
								>
									<ArrowBackIcon />
								</Button>
								<Button
									color="inherit"
									aria-label="Home"
									onClick={this.goHome.bind(this)}
									className="white_button"
								>
									<HomeIcon />
								</Button>
							</div>
						) : (
							<div></div>
						)}

						<Typography
							variant="h6"
							color="inherit"
							className={classes.flex}
							style={{
								maxHeight: "100%",
								overflowY: "hidden",
								fontSize: 16,
								paddingLeft: "5px",
							}}
						>
							{locationTitle}
						</Typography>
						{waitingRequestsBtn}
						{this.state.auth && (
							<div>
								<Button
									aria-owns={open ? "menu-appbar" : null}
									aria-haspopup="true"
									onClick={this.handleMenu.bind(this)}
									color="inherit"
									className="white_button"
								>
									<ProfileIcon fontSize="large" />
								</Button>
								<Menu
									id="menu-appbar"
									anchorEl={anchorEl}
									anchorOrigin={{ vertical: "top", horizontal: "right" }}
									transformOrigin={{ vertical: "top", horizontal: "right" }}
									open={open}
									onClose={this.handleClose.bind(this)}
								>
									<MenuItem
										style={{ display: "flex" }}
										onClick={this.onLogoClick.bind(this)}
									>
										<img src={logo} alt="logo" style={{ width: "250px" }} />
									</MenuItem>
									<Typography
										style={{
											color: "#005BBA",
											fontSize: 12,
										}}
									>
										Version {version}
									</Typography>
									<MenuItem
										style={{ display: "flex", textAlign: "center" }}
									>
										<ListItemIcon
											className={classes.icon}
											style={{ color: "#FE5815" }}
										>
											<ProfileIcon />
										</ListItemIcon>
										<Typography
											style={{
												fontSize: 20,
												color: "#005BBA",
											}}
										>
											{this.props.activeUser !== undefined
												? this.props.activeUser.email
												: ""}
										</Typography>
									</MenuItem>
									<MenuItem
										onClick={this.synchronization.bind(this)}
										color="secondary"
										style={{ margin: "auto", display: "flex" }}
									>
										<ListItemIcon
											className={classes.icon}
											style={{ color: "#FE5815" }}
										>
											<SyncIcon />
										</ListItemIcon>
										<Typography
											style={{
												color: "#005BBA",
												fontSize: 20,
											}}
										>
											Synchroniser
										</Typography>
									</MenuItem>
									<MenuItem
										onClick={this.signout.bind(this)}
										style={{ margin: "auto", display: "flex" }}
									>
										<ListItemIcon
											className={classes.icon}
											style={{ color: "#FE5815" }}
										>
											<FontAwesomeIcon icon={faSignOutAlt} className="fa-lg" />
										</ListItemIcon>
										<GoogleLogout
											clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
											onLogoutSuccess={this.logout.bind(this)}
											className="btn-logout"
											icon={false}
											buttonText="Déconnexion"
										></GoogleLogout>
									</MenuItem>
								</Menu>
							</div>
						)}
					</Toolbar>
				</AppBar>
			</div>
		);
	}
}

ExternalMenuAppBar.propTypes = {
	classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		locationTitle: state.locationTitle,
		activeUser: state.activeUser,
		synchro: state.synchro,
		parameter: state.parameter,
		waitingRequests: state.serviceWorker.waitingRequests,
		hideMenu: state.layout.hideMenu,
		siteMonitoring: state.siteMonitoring,
		siteMonitoringsFilters: state.siteMonitorings.siteMonitoringsFilters,
		context: state.context,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		loadLocationTitle: () => dispatch(loadLocationTitle()),
		clearUsers: () => dispatch(clearUsers()),
		getSynchroActiveUser: (currentState, hideError) =>
			dispatch(ownProps.getSynchroActiveUser(currentState, hideError)),
		actualizeWaitingRequests: () => dispatch(actualizeWaitingRequests()),
		setDebugging: (debugging) => dispatch(setDebugging(debugging)),
		synchronization: (state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters) =>
			dispatch(
				ownProps.synchronization(
					state,
					stateAccessor,
					history,
					interventionsFilters,
					siteMonitoringsFilters,
					true
				)
			),
	};
};

export default compose(
	withAuth,
	withStyles(styles),
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(ExternalMenuAppBar);
